import {AbstractControl} from '@angular/forms';
import {CNPJ} from "./cnpj.util";

export function validatorCNPJ(control: AbstractControl) {
  const value = control.value;

  if (!value || typeof value !== 'string') {
    return {validateCnpj: true};
  }

  const cnpj = value.trim();
  if (cnpj.length < 14 || cnpj.length > 18) {
    return {validateCnpj: true};
  }

  if (!CNPJ.isValid(cnpj)) {
    return {validateCnpj: true};
  }

  return null;
}
